document.getElementById('continue-shopping-btn').addEventListener('click', function() {
    console.log('Butonul a fost apăsat!');  // Mesaj pentru a verifica dacă evenimentul este detectat
    var cartDrawerContainer = document.querySelector('.cart-drawer-container');
    if (cartDrawerContainer) {
        cartDrawerContainer.classList.remove('active');
    }
    window.scrollTo(0, 0);  // Opțional: Scrollează pagina în sus
});
